import { parseISO } from 'date-fns'

export const stripHtml = (str: string): string => {
  const div = document.createElement('div')
  div.innerHTML = str
  return div.textContent ?? div.innerText ?? str
}

export const parseTimestamp = (timestamp: string): Date => {
  const hasTimezone =
    /[Z+-]\d{2}:?\d{2}$/.test(timestamp) || timestamp.endsWith('Z')

  if (!hasTimezone) {
    return parseISO(timestamp + 'Z')
  }
  return parseISO(timestamp)
}
